import axios from "./axios";

export default {
  login(data) {
    return axios.post("/auth/login", data, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    });
  },

  logout() {
    return axios.post("/auth/logout");
  },

  changePassword(data) {
    return axios.post("/auth/password", data, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
    });
  },

  getMenuRouters() {
    return axios.get("/auth/menu/routers");
  },

  me() {
    return axios.get("/auth/me");
  },
};
